import { datadogLogs } from "@datadog/browser-logs";
import { useCallback } from "react";

/**
 * Hook that returns a memoized info logging function.
 * @param {string} message - The info message to log
 * @param {object} [context] - Optional context object to include in the log
 * @returns {void}
 */
export default function useInfoLogger() {
  return useCallback((message: string, context?: object) => {
    return datadogLogs.logger.info(message, context);
  }, []);
}
